import Icon from 'components/icons/Icon';
import AccountContext from 'context/AccountContext';
import React, { useContext } from 'react';
import { ColumnWithMargins } from 'styles/ContainerStyles';

type AimoPlusIconProps = {
  hasCorporateAccount?: boolean;
};

const AimoPlusIcon = ({ hasCorporateAccount = false }: AimoPlusIconProps) => {
  const { customer } = useContext(AccountContext);

  if (!customer?.aimoPlusSubscriber || hasCorporateAccount) {
    return null;
  }

  return (
    <ColumnWithMargins ml={5} testID="aimo-plus-icon">
      <Icon name="Aimo-Plus" />
    </ColumnWithMargins>
  );
};

export default AimoPlusIcon;
